<template>
  <el-dialog
    title="回复提问"
    :visible.sync="visible"
    width="900px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="90px"
      size="small"
    >
      <el-form-item label="问题描述">
        <div>{{ model.question.content }}</div>
      </el-form-item>
      <el-form-item label="回复内容" prop="content">
        <el-input v-model="model.content" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { createWikiComment } from '@/service/getData'
import RichEditor from '@/components/rich-editor'

export default {
  components: {
    RichEditor,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        content: [{ required: true, message: '回复内容不能为空' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await createWikiComment(this.model)
          if (res.code == 0) {
            this.visible = false
            this.$emit('created', res.data)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
/deep/.ql-editor {
  min-height: 200px;
}

/deep/.ql-formats {
  line-height: 0;
}
</style>